import { boolPropsToClassNames } from 'common/utils/style.utils';
import { StyledErrorMessage } from './FilterSetForm.style';

const ErrorMessage = ({ validationError, type }) => {
  return (
    <StyledErrorMessage
      className={boolPropsToClassNames({
        hidden: validationError?.type !== type
      })}
    >
      {validationError?.message}
    </StyledErrorMessage>
  );
};

export default ErrorMessage;
